import styled from '@emotion/styled';
import React from 'react';

const StyledEnglish = styled.div((props) => ({
  whiteSpace: 'pre-wrap',
  color: props.empty ? '#777' : '#000',
  fontSize: '1.3em',
  fontWeight: 'bold',
  marginBottom: 10,
}));

const StyledFrench = styled.div((props) => ({
  whiteSpace: 'pre-wrap',
  color: props.empty ? '#777' : '#000',
  marginTop: 10,
}));

export default function Quote({ text, text_fr }) {
  return (
    <>
      <StyledEnglish
        empty={!text}
        dangerouslySetInnerHTML={{
          __html: `${text ? text : 'Add quote'}`,
        }}
      />
      {text_fr ? (
        <StyledFrench
          dangerouslySetInnerHTML={{
            __html: text_fr,
          }}
        />
      ) : null}
    </>
  );
}
